import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const OrderReturnPages = {
  list: 'ListOrderReturn',
  add: 'AddOrderReturn',
  edit: 'EditOrderReturn',
}

const { t } = i18n.global

const title = t('pages.returns')
const path = '/order-return'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: OrderReturnPages.add,
  component: () => import('@/pages/mainPageWithRoute/order-return/AddOrderReturnPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: OrderReturnPages.edit,
  component: () => import('@/pages/mainPageWithRoute/order-return/EditOrderReturn.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: OrderReturnPages.list,
  component: () => import('@/pages/mainPageWithRoute/order-return/ListOrderReturn.vue'),
  meta: { title, requiresAuth: true },
}

export const OrderReturns: RouteRecordRaw = {
  path,
  name: 'OrderReturns',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
